import React from 'react'
import AmbulatoryUnitStepLayout from 'presentation/doctor/layouts/AmbulatoryUnitStep'

function AmbulatoryUnitStep() {
  return <AmbulatoryUnitStepLayout />
}

export default AmbulatoryUnitStep
